import React from 'react';

// columns: [{ dataField, text, formatter? }]
export default function VirtualizedTable({
  items,
  columns,
  rowClassName,
  rowHeight = 44,
  height = 500,
}) {
  // items is the full filtered list
  return (
    <div style={{ width: '100%', overflow: 'auto' }}>
      <table className="table table-sm">
        <thead>
          <tr>
            {columns.map((col, i) => (
              <th key={col.dataField || i}>{col.text}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {items.map((row, idx) => (
            <tr key={row.id || idx} className={rowClassName ? rowClassName(row) : ''}>
              {columns.map((col, i) => (
                <td key={col.dataField || i}>
                  {col.formatter ? col.formatter(row[col.dataField], row) : row[col.dataField]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
